import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Key = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M12.3825 10.9682L4.20712 2.79285L2.79291 4.20706L4.0858 5.49995L2.29291 7.29285L3.70712 8.70706L5.50001 6.91417L7.0858 8.49995L5.29291 10.2928L6.70712 11.7071L8.50001 9.91417L10.9683 12.3824C10.3576 13.2685 10 14.3425 10 15.5C10 18.5375 12.4624 21 15.5 21C18.5376 21 21 18.5375 21 15.5C21 12.4624 18.5376 9.99995 15.5 9.99995C14.3425 9.99995 13.2685 10.3575 12.3825 10.9682ZM15.5 19C17.433 19 19 17.433 19 15.5C19 13.567 17.433 12 15.5 12C13.567 12 12 13.567 12 15.5C12 17.433 13.567 19 15.5 19Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Key;
